import { gql } from '@apollo/client'

export const GET_HUBSPOT_VISITOR_IDENTIFICATION = gql`
  query getHubspotVisitorIdentification {
    hubspotVisitorIdentification {
      token
      email
      expiresAt
    }
  }
`
